var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#141416}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.8,68.1c-0.2-0.1-0.4-0.1-0.6-0.2C25.3,67.9,25.5,68,25.8,68.1z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5,27.3c0-4.5-1.6-8.2-4.2-11.1c0.4-1,1.8-5.3-0.4-10.9c0,0-3.5-1.1-11.3,4.2c-3.3-0.9-6.8-1.4-10.2-1.4 c-3.5,0-6.9,0.5-10.3,1.4c-7.8-5.3-11.3-4.2-11.3-4.2c-2.2,5.7-0.8,9.9-0.4,10.9c-2.6,2.9-4.2,6.6-4.2,11.1 c0,15.9,9.6,19.4,18.7,20.4c-1.2,1-2.2,2.9-2.6,5.5c-2.4,1.1-8.3,2.9-11.9-3.4c0,0-2.2-4-6.3-4.2c0,0-4,0-0.3,2.5 c0,0,2.7,1.2,4.5,6c0,0,2.4,7.4,13.8,4.9c0,1.6,0,6,0,10.4c3.3,0.8,6.7,1.3,10.2,1.3c3.5,0,6.9-0.5,10.2-1.3c0-5.4,0-11.4,0-14.1 c0-3.9-1.3-6.4-2.8-7.7C56.9,46.7,66.5,43.2,66.5,27.3z",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.58c2fd6a696b153556842bd7dd84515c.svg";
export { ForwardRef as ReactComponent };